import Loader from "react-ts-loaders";

import styles from "./loading.module.scss";

const Loading = ({ green }: { green?: boolean }) => (
  <div className={`${styles.container}    ${green && styles.green}`}>
    <Loader type="spinner" color="white" />
  </div>
);

export default Loading;
